'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var camelCase = require('camelcase');
var isPlainObject = require('is-plain-object');

var camelizeObject = function camelizeObject(data, exceps) {
  if (Array.isArray(data)) return data.map(function (item) {
    return camelizeObject(item);
  });
  if (!isPlainObject(data)) return data;

  return Object.keys(data).reduce(function (result, key) {
    var newKey = isException(key, exceps || []) ? key : camelCase(key);
    if (isPlainObject(data[key])) return camelDeepObject(newKey, result, data[key], exceps);
    if (Array.isArray(data[key])) return camelArray(newKey, result, data[key], exceps);
    return camelPropery(newKey, result, data[key]);
  }, {});
};

var isException = function isException(key, exceps) {
  return exceps.indexOf(key) > -1;
};

var camelDeepObject = function camelDeepObject(newKey, result, data, exceps) {
  var func = function func() {
    return camelizeObject(data, exceps);
  };
  return applyOnResult(newKey, result, func);
};

var camelArray = function camelArray(newKey, result, dataArr, exceps) {
  var func = function func() {
    return dataArr.map(function (item) {
      return camelizeObject(item, exceps);
    });
  };
  return applyOnResult(newKey, result, func);
};

var camelPropery = function camelPropery(newKey, result, data) {
  var func = function func() {
    return data;
  };
  return applyOnResult(newKey, result, func);
};

var applyOnResult = function applyOnResult(newKey, result, func) {
  var partial = {};
  partial[newKey] = func();
  return _extends({}, result, partial);
};

module.exports = camelizeObject;


//////////////////
// WEBPACK FOOTER
// ./node_modules/camelobj/dist/index.js
// module id = 232
// module chunks = 1 2